module.exports = __webpack_public_path__ + "img/arrow_up_w.20988da8.svg";